import * as React from 'react';
import { connect } from 'react-redux';
import { ProgressBar } from 'react-bootstrap';
import { handlePreviousSalesStep, setStep } from '../../../../actions/salesActions';
import { navigateTo } from '../../../../actions/navigationActions';
import { GET_BUILDING_QUOTATION, GET_HOME_CONTENT_QUOTATION } from '../../../../routes/routes';
import { PRODUCT_BUILDING } from '../../../../constants/constants';
import PersonalInformation from '../../PersonalInformation/PersonalInformation';
import CreditHistoryCheck from '../../CreditHistoryCheck/CreditHistoryCheck';
import AddressSelect from '../Address/AddressSelect';
import AddressCreate from '../Address/AddressCreate';
import OwnerTenant from '../OwnerTenant/OwnerTenant';
import Financed from '../Financed/Financed';
import BuildingUse from '../BuildingUse/BuildingUse';
import BuildingAge from '../BuildingAge/BuildingAge';
import PropertyInfo from '../PropertyInfo/PropertyInfo';
import PropertyBorders from '../PropertyBorders/PropertyBorders';
import BuildingDetails from '../BuildingDetails/BuildingDetails';
import AlternativePower from '../BuildingDetails/AlternativePower';
import ThatchRoof from '../BuildingDetails/ThatchRoof';
import InsuranceHistory from '../InsuranceHistory/InsuranceHistory';
import ClaimsHistory from '../ClaimsHistory/ClaimsHistory';
import ClaimsCapture from '../ClaimsHistory/ClaimsCapture';
import PropertyRating from '../PropertyRating/PropertyRating';
import ReplacementValue from '../ReplacementValue/ReplacementValue';
import './JourneyBuilder.css'

class JourneyBuilder extends React.Component<any, any>  {
    constructor(props) {
        super(props);
        this.state = {
        };
        this.handleBack = this.handleBack.bind(this);
    }

    async handleBack() {
        let navigateToLanding = (this.props.sales.selectedSalesStep.step === 1);
        if (this.props.sales.selectedSalesStep.step === 3) {
            let hasAddress = (this.props.sales.addresses?.length > 0);
            navigateToLanding = this.props.sales.selectedSalesStep.subStep === 1 || !hasAddress;
        }

        //If running alternative journey, then user can't navigate back to landing.
        if (this.props.sales.buildingContinueQuote) {
            navigateToLanding = false;
        }

        if (navigateToLanding) {
            let destination = (this.props.sales.addProduct === PRODUCT_BUILDING) ? GET_BUILDING_QUOTATION : GET_HOME_CONTENT_QUOTATION;
            await this.props.dispatchAction(navigateTo(destination));
        }
        else {
            let navigateBack = true;
            let retainSubsteps = true;
            retainSubsteps = (this.props.sales.selectedSalesStep.step === 4 && this.props.sales.selectedSalesStep.subStep === 1) ? false : retainSubsteps;
            retainSubsteps = (this.props.sales.selectedSalesStep.step === 5 && this.props.sales.selectedSalesStep.subStep === 1) ? false : retainSubsteps;

            if (this.props.sales.selectedSalesStep.step === 6 && this.props.sales.selectedSalesStep.subStep === 1 && this.props.sales.buildingStorage) {
                navigateBack = false;
                this.props.dispatchAction(setStep(4, 1));
            }

            if (this.props.sales.selectedSalesStep.step === 9 && this.props.sales.selectedSalesStep.subStep === 3 && !this.props.sales.buildingAlternativePower) {
                navigateBack = false;
                this.props.dispatchAction(setStep(9, 1));
            }

            retainSubsteps = (this.props.sales.selectedSalesStep.step === 10 && this.props.sales.selectedSalesStep.subStep === 1) ? false : retainSubsteps;

            if (this.props.sales.selectedSalesStep.step === 12 && this.props.sales.selectedSalesStep.subStep === 1) {
                retainSubsteps = (Number(this.props.sales.claimsCount) >= 3 || (Number(this.props.sales.claimsCount) > 0 && this.props.sales.propertyBorders.river));
            }

            if (navigateBack) {
                await this.props.dispatchAction(handlePreviousSalesStep(retainSubsteps));
            }
        }
    }

    public render() {
        let btnBackEnabled = true;
        let stepContent: any = <div></div>;

        if (!this.props.sales.buildingContinueQuote) {
            switch (this.props.sales.selectedSalesStep.step) {
                case 1: {
                    stepContent = <PersonalInformation />;
                    break;
                }
                case 2: {
                    stepContent = <CreditHistoryCheck />;
                    break;
                }
                case 3: {
                    if (this.props.sales.selectedSalesStep.subStep === 1) {
                        stepContent = <AddressSelect />;
                    }
                    if (this.props.sales.selectedSalesStep.subStep === 2) {
                        stepContent = <AddressCreate />;
                    }
                    break;
                }
                case 4: {
                    if (this.props.sales.selectedSalesStep.subStep === 1) {
                        stepContent = <OwnerTenant />;
                    }
                    if (this.props.sales.selectedSalesStep.subStep === 2) {
                        stepContent = <Financed />;
                    }
                    break;
                }
                case 5: {
                    stepContent = <BuildingUse />;
                    break;
                }
                case 6: {
                    stepContent = <BuildingAge />;
                    break;
                }
                case 7: {
                    stepContent = <PropertyInfo />;
                    break;
                }
                case 8: {
                    stepContent = <PropertyBorders />;
                    break;
                }
                case 9: {
                    if (this.props.sales.selectedSalesStep.subStep === 1) {
                        stepContent = <BuildingDetails />;
                    }
                    if (this.props.sales.selectedSalesStep.subStep === 2) {
                        stepContent = <AlternativePower />;
                    }
                    if (this.props.sales.selectedSalesStep.subStep === 3) {
                        stepContent = <ThatchRoof />;
                    }
                    break;
                }
                case 10: {
                    stepContent = <InsuranceHistory />;
                    break;
                }
                case 11: {
                    if (this.props.sales.selectedSalesStep.subStep === 1) {
                        stepContent = <ClaimsHistory />;
                    }
                    if (this.props.sales.selectedSalesStep.subStep === 2) {
                        stepContent = <ClaimsCapture />;
                    }
                    break;
                }
                case 12: {
                    stepContent = <PropertyRating />;
                    break;
                }
                case 13: {
                    stepContent = <ReplacementValue />;
                    break;
                }
            }
        }
        else {
            switch (this.props.sales.selectedSalesStep.step) {
                case 1: {
                    if (this.props.sales.selectedSalesStep.subStep === 1) {
                        stepContent = <ClaimsHistory />;
                        btnBackEnabled = false;
                    }
                    if (this.props.sales.selectedSalesStep.subStep === 2) {
                        stepContent = <ClaimsCapture />;
                    }
                    break;
                }
                case 2: {
                    stepContent = <ReplacementValue />;
                    break;
                }
            }
        }

        return (
            <div id="BuildingJourneyBuilder" className="pt-lg-5 p-lg-0 logged-in">
                <div className="col-12 pb-4 text-lg-center text-md-center">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10 col-md-12">
                                <div className="row justify-content-center">
                                    <div className="col-2 col-md-3 col-lg-3 col-xl-2 pt-lg-2 text-center align-self-center">
                                        <div className="BackRectangle d-none d-lg-block d-md-block">
                                            {btnBackEnabled &&
                                                <button onClick={this.handleBack} className="Back cursor-pointer"><img src="./images/OnlineQuotation/icon-back-button-desktop.png" alt="" /></button>
                                            }
                                        </div>
                                        <div className="sidenav d-lg-none d-md-none" id="mySidenav">
                                            {btnBackEnabled &&
                                                <button onClick={this.handleBack} className="Back cursor-pointer" id="about"><img src="./images/OnlineQuotation/icons-navigation-quote-back-btn.png" alt="" /></button>
                                            }
                                        </div>
                                    </div>
                                    <div className="col-10 col-md-9 col-lg-9 col-xl-10 p-0 text-center align-self-center">
                                        <div>
                                            <ProgressBar variant="success" now={Math.trunc((this.props.sales.selectedSalesStep.step / this.props.sales.salesStepConfiguration.steps.length) * 100)} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10 col-md-12 nopa">
                                <div className="ssp-addportable-possessions-crown-icon mt-0px mb-20px mt-44px text-center">
                                    <div className="ssp-sales-journey-crown-icon" title="Add insurance"></div>
                                </div>
                                {stepContent}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        sales: state.sales,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e)
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(JourneyBuilder)
